module.exports = __webpack_public_path__ + "img/logo_menu_blanc.75d25a69.png";